<template>
  <div class="inputs">
    <div class="section-header">Trade Show Details</div>
    <div class="row">
      <div class="col">
        <div class="form-group mb-0">
          <label for="name">Trade Show Name</label
          ><help-icon
            v-if="tradeShow._id"
            :text="`Name cannot be edited at this time.`"
          ></help-icon>
          <b-form-input
            id="name"
            type="text"
            v-model="tradeShow.name"
            required
            :disabled="submitting || tradeShow._id ? true : false"
          ></b-form-input>
        </div>
      </div>
      <div class="col"></div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label for="phone">Phone</label>
          <b-form-input
            id="phone"
            type="text"
            v-model="tradeShow.phone"
            :disabled="submitting"
          ></b-form-input>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label for="email">Email</label>
          <b-form-input
            id="email"
            type="email"
            v-model="tradeShow.email"
            :disabled="submitting"
            :required="false"
          ></b-form-input>
        </div>
      </div>
    </div>
    <div class="section-header">Address</div>
    <div class="row">
      <div class="col">
        <div class="px-2">
          <AddressFields
            :sending="submitting"
            :address="tradeShow.address"
            :autoComplete="true"
            :required="false"
          />
        </div>
      </div>
    </div>
    <div class="section-header">
      Contacts
      <b-button size="sm" variant="primary" @click="addContact">+</b-button>
    </div>
    <div
      v-for="(contact, index) in tradeShow.contacts"
      :key="`contact-${index}`"
    >
      <div class="row mt-2">
        <div class="col contact-col">
          <b-input
            type="text"
            v-model="contact.firstName"
            placeholder="First Name"
          ></b-input>
        </div>
        <div class="col contact-col">
          <b-input
            type="text"
            v-model="contact.lastName"
            placeholder="Last Name"
          ></b-input>
        </div>
        <div class="col contact-col">
          <b-input
            type="email"
            v-model="contact.email"
            placeholder="Email"
          ></b-input>
        </div>
        <div class="col contact-col">
          <b-input
            type="text"
            v-model="contact.phone"
            placeholder="Phone"
          ></b-input>
        </div>
        <div class="col contact-col">
          <b-button variant="danger" size="sm" @click="removeContact(index)"
            >X</b-button
          >
        </div>
      </div>
    </div>
    <div class="section-header">
      Locations
      <b-button size="sm" variant="primary" @click="addLocation">+</b-button>
    </div>
    <div
      v-for="(location, index) in tradeShow.locations"
      :key="`location-${index}`"
      class="mb-3"
    >
      <div class="row mt-2">
        <div class="col location-col address">
          <b-input
            type="text"
            v-model="location.name"
            placeholder="Location Name"
          ></b-input>
        </div>
        <div class="col location-col">
          <b-button variant="danger" size="sm" @click="removeLocation(index)"
            >X</b-button
          >
        </div>
      </div>
      <AddressFields
        class="px-3 mt-2 address"
        :sending="submitting"
        :address="location.address"
        :autoComplete="true"
        :required="false"
      />
    </div>
  </div>
</template>

<script>
import AddressFields from '@/components/AddressFields.vue'
import HelpIcon from '@/components/HelpIcon.vue'

export default {
  name: 'VendorFormFields',
  props: {
    tradeShow: {
      type: Object,
      required: true,
    },
    submitting: {
      type: Boolean,
      required: true,
    },
  },
  components: { AddressFields, HelpIcon },
  inject: {},
  data: function () {
    return {}
  },
  watch: {},
  methods: {
    addContact() {
      const newContact = {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
      }
      this.tradeShow.contacts.push(newContact)
    },
    removeContact(index) {
      this.tradeShow.contacts.splice(index, 1)
    },
    addLocation() {
      const newLocation = {
        name: '',
        address: {},
      }
      this.tradeShow.locations.push(newLocation)
    },
    removeLocation(index) {
      this.tradeShow.locations.splice(index, 1)
    },
  },
  mounted() {},
  computed: {},
}
</script>

<style lang="scss" scoped>
.custom-checkbox {
  display: inline-block;
  margin-left: 4px;
}

.section-header {
  font-size: 18px;
  text-decoration: underline;
  margin-bottom: 6px;
  margin-top: 8px;
  font-weight: 500;
}

.contact-col {
  padding-left: 5px;
  padding-right: 5px;

  &:first-of-type {
    padding-left: 15px;
  }
}

.address {
  max-width: 400px;
}
</style>
